const enabled = location.pathname === '/app' || location.pathname.startsWith('/app/');
let port: MessagePort | null = null;
let settle: () => void = () => {};
let settled = false;
let storageTimer = 0;
let active = true;
const ready = new Promise<void>((resolve) => { settle = resolve; });
const finish = () => { if (!settled) { settled = true; settle(); } };
const supportedKey = (key: string) => /^nianfo\.(settings\.v1|buddha\.v1|presets\.v1|app\.playback\.v1|timeline\.edit\.[A-Za-z0-9_-]+)$/.test(key);
function snapshot(): Record<string, string> {
  const storage: Record<string, string> = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && supportedKey(key)) storage[key] = localStorage.getItem(key)!;
  }
  return storage;
}
function sendStorage(): void {
  clearTimeout(storageTimer);
  storageTimer = window.setTimeout(() => port?.postMessage({ type: 'storage', storage: snapshot() }), 80);
}

if (enabled) {
  const originalSet = Storage.prototype.setItem, originalRemove = Storage.prototype.removeItem, originalClear = Storage.prototype.clear;
  Storage.prototype.setItem = function(key, value) { originalSet.call(this, key, value); if (this === localStorage && supportedKey(String(key))) sendStorage(); };
  Storage.prototype.removeItem = function(key) { originalRemove.call(this, key); if (this === localStorage && supportedKey(String(key))) sendStorage(); };
  Storage.prototype.clear = function() { originalClear.call(this); if (this === localStorage) sendStorage(); };
  window.addEventListener('message', (event) => {
    const localParent = /^(http:\/\/(localhost|127\.0\.0\.1):[0-9]+)$/.test(event.origin);
    const iframeHost = window.parent !== window && event.source === window.parent && (['tauri://localhost', 'http://tauri.localhost', 'https://tauri.localhost'].includes(event.origin) || localParent);
    const nativeHost = window.parent === window && event.source === window && event.origin === location.origin;
    if ((!iframeHost && !nativeHost) || event.ports.length !== 1) return;
    const message = event.data;
    if (!message || message.protocol !== 'sxz.nianfo.storage' || message.version !== 1 || message.type !== 'connect') return;
    const storage = message.storage;
    if (nativeHost && storage !== null) return;
    if (storage !== null && (!storage || typeof storage !== 'object' || Array.isArray(storage) || Object.entries(storage).some(([key, value]) => !supportedKey(key) || typeof value !== 'string'))) return;
    if (port) port.close();
    port = event.ports[0];
    if (storage !== null) {
      for (const key of Object.keys(snapshot())) originalRemove.call(localStorage, key);
      for (const [key, value] of Object.entries(storage as Record<string, string>)) originalSet.call(localStorage, key, value);
    }
    port.onmessage = ({ data }) => {
      if (data?.type === 'navigate' && (data.direction === -1 || data.direction === 1)) history.go(data.direction);
      else if (data?.type === 'reload') location.reload();
      else if (data?.type === 'lifecycle' && (data.state === 'active' || data.state === 'inactive')) {
        active = data.state === 'active';
        window.dispatchEvent(new CustomEvent('nianfo-host-lifecycle', { detail: { active } }));

      }
    };
    port.postMessage({ type: 'navigation', url: location.href });
    port.postMessage({ type: 'storage', storage: snapshot() });
    document.documentElement.classList.add('app-hosted');
    finish();
  });
  for (const name of ['pageshow', 'popstate', 'hashchange']) window.addEventListener(name, () => port?.postMessage({ type: 'navigation', url: location.href }));
  window.addEventListener('pagehide', () => { if (port) port.postMessage({ type: 'storage', storage: snapshot() }); });
  if (window.parent === window) finish();
} else finish();

export const appHost = {
  enabled, ready,
  get connected() { return port !== null; },
  get active() { return active; },
  requestFullscreen(): boolean { if (!port) return false; port.postMessage({ type: 'fullscreen' }); return true; },
};
